import CompanyScreen from './CompanyScreen';

export default CompanyScreen;
